import UpDownLoadReport from '../../pages/ad/ad-customer/up-down-cost-report'
/**
 * 广告账户下载异常的路由配置。
 *
 * 如何访问"流程详情"路由：
 * this.$router.push({name: 'CustomerWorkflowDetail', params: {flowType: t, flowId: id}})
 */

export default [
  {
    name: 'UpDownLoadReport',
    path: '/up_down_cost_report',
    meta: { title: '上下游结算数据' },
    component: UpDownLoadReport
  }
]
